export default {
    NUMBER: 'NUMBER',
    TEXT: 'TEXT',
    SECURITY_NAME: 'SECURITY_NAME',
    CONTACTS: 'CONTACTS'
};
